import {
  Chart,
  ChartArea,
  ChartCategoryAxisLabels,
  ChartPlotArea,
  ChartProps,
  ChartSeries,
  ChartSeriesItem,
  ChartSeriesMarkers,
  ChartTooltip,
  ChartXAxis,
  ChartXAxisItem,
  ChartYAxis,
  ChartYAxisItem,
  MarkersVisualArgs,
  SharedTooltipContext,
  TooltipContext,
  XAxisNotes,
  YAxisNotes,
} from "@progress/kendo-react-charts";
import * as React from "react";
import { CSSProperties } from "react";
import { defaultAxisFormatter, defaultMarkerRenderer } from "./transformers";
import { drawing, Text } from "@progress/kendo-drawing";
import { ScatterChartTooltip } from "./ScatterChartTooltip";

export type ScatterItem = {
  category?: string;
  color?: string;
  xField: any;
  yField: any;
};
export interface ScatterChartProps extends ChartProps {
  items: ScatterItem[];
  xAxisTitle?: string;
  yAxisTitle?: string;
  xAxisNotes?: XAxisNotes;
  yAxisNotes?: YAxisNotes;
  xAxisFormatter?(e?: number): string;
  yAxisFormatter?(e?: number): string;
  currencyFormatter(e?: number): string;
  getItemValue(e?: string): number;
  tooltipRenderer?(
    context: TooltipContext | SharedTooltipContext,
    valueAxisFormatter: (e?: number) => string,
    currencyFormatter: (e?: number) => string,
    getItemValue: (e?: string) => number
  ): React.ReactElement;
  chartStyle?: CSSProperties;
  legendVisible?: boolean;
  markerRenderer?: (e: MarkersVisualArgs) => drawing.Element;
  xMax?: number;
  yMax?: number;
  height?: number;
  width?: number;
}

export const RiskVsreturnScatterChart = ({
  items,
  xAxisTitle,
  yAxisTitle,
  xAxisFormatter = defaultAxisFormatter,
  yAxisFormatter = defaultAxisFormatter,
  tooltipRenderer = ScatterChartTooltip,
  getItemValue,
  legendVisible,
  markerRenderer = defaultMarkerRenderer,
  chartStyle,
  xMax,
  yMax,
  xAxisNotes,
  yAxisNotes,
  currencyFormatter,
  height,
  width,
  ...props
}: ScatterChartProps) => {
  return (
    // @ts-ignore - bad type missing children
    <Chart
      className={"chart-resizable"}
      style={{ width: width || "100%", height }}
      {...props}
    >
      <ChartPlotArea padding={{ right: 400 }} height={height} width={width} />
      <ChartArea background={"transparent"} />
      <ChartTooltip
        opacity={0.9}
        color={"var(--tooltip-color)"}
        background={"var(--tooltip-background-color)"}
        render={(context: any) =>
          tooltipRenderer(
            context,
            xAxisFormatter,
            currencyFormatter,
            getItemValue
          )
        }
      />
      <ChartSeries>
        <ChartSeriesItem
          colorField={"color"}
          type="scatter"
          data={items}
          xField="xField"
          yField="yField"
        >
          <ChartSeriesMarkers visual={markerRenderer} />
        </ChartSeriesItem>
      </ChartSeries>
      <ChartXAxis>
        <ChartXAxisItem
          name="xAxis"
          notes={xAxisNotes}
          max={xMax}
          title={{
            color: "var(--color)",
            text: xAxisTitle,
          }}
        >
          <ChartCategoryAxisLabels
            color={"var(--color)"}
            rotation={"auto"}
            content={(e: any) => xAxisFormatter(e.value)}
          />
        </ChartXAxisItem>
      </ChartXAxis>
      <ChartYAxis>
        <ChartYAxisItem
          name="yAxis"
          max={yMax}
          notes={yAxisNotes}
          title={{
            color: "var(--color)",
            text: yAxisTitle,
          }}
        >
          <ChartCategoryAxisLabels
            color={"var(--color)"}
            content={(e: any) => yAxisFormatter(e.value)}
          />
        </ChartYAxisItem>
      </ChartYAxis>
    </Chart>
  );
};

export default RiskVsreturnScatterChart;
